
export class TransferDelete {
    ids: Array<number> = [];

    public addTransferToDelete(id: number) {
        this.ids.push(id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/transfer-delete.ts